import { Primary, PrimaryProps } from '@cinch-labs/design-system'
import { Guard, valueIsPresent } from '@cinch-labs/shared-util'
import cx from 'classnames'
import styles from './cta-button.module.css'

export type CtaButtonProps = {
  label: string
  url: string
} & PrimaryProps

const mergeClassNames = (classNames?: { button?: string }) => ({
  ...classNames,
  button: cx(styles.button, classNames?.button),
})

export const CtaButton: React.FC<CtaButtonProps> = ({
  label,
  url,
  classNames,
}) => {
  Guard.ensure([
    valueIsPresent(url, 'CTA button URL'),
    valueIsPresent(label, 'CTA button label'),
  ])

  return (
    <Primary element="a" href={url} classNames={mergeClassNames(classNames)}>
      {label}
    </Primary>
  )
}
